import z from "zod";
import { webappClient } from "../clients";
import { validateResponse } from "../validation";
import { getLocaleWithCountry } from "app-settings/localesAndCurrencies";

const fetchTrustpilotScoreResponseSchema = z.object({
  totalReviews: z.number(),
  scoreValue: z.number(),
  trustpilotLink: z.string(),
});

export async function fetchTrustpilotScore(locale?: string) {
  const data = await webappClient
    .get("api/airhelp_score", {
      searchParams: locale ? { locale: getLocaleWithCountry(locale) } : undefined,
    })
    .json();

  return validateResponse({
    data,
    schema: fetchTrustpilotScoreResponseSchema,
    tag: "Trustpilot API response",
  });
}
